<div mdbModal #modalRutasDivididas="mdb-modal" class="modal fade" id="dvModalRutasDivididas" tabindex="-1" role="dialog"
  aria-labelledby="modalRutasDivididasLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }"
  style="z-index: 1050;">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="modalRutasDivididasLabel">
          <mdb-icon fas icon="route" class="mr-2"></mdb-icon>
          División de Rutas
        </h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="cerrar()">
          <span aria-hidden="true">×</span>
        </button>
      </div>

      <div class="modal-body" style="overflow-y: auto; max-height: 70vh;">
        <!-- Información general -->
        <div class="alert alert-info mb-3" role="alert">
          <mdb-icon fas icon="info-circle" class="mr-2"></mdb-icon>
          <span>Información</span>
          <div class="mt-1">
            Se ha generado una ruta de <strong>{{ totalPuntos }}</strong> puntos, dividida en <strong>{{
              rutasDivididas.length }}</strong> rutas.
          </div>
        </div>

        <!-- Lista de rutas -->
        <div *ngFor="let ruta of rutasDivididas; let i = index" class="card mb-3">
          <div class="card-header d-flex justify-content-between align-items-center header-ruta"
            [class.header-ruta-activa]="rutasMostradas.has(ruta.numero)">
            <div class="d-flex align-items-center">
              <mdb-icon fas icon="map-marker-alt" class="mr-2"></mdb-icon>
              <h5 class="mb-0">Ruta {{ ruta.numero }}</h5>
            </div>
            <span class="badge" [class.badge-primary]="!rutasMostradas.has(ruta.numero)"
              [class.badge-light]="rutasMostradas.has(ruta.numero)"
              [class.text-primary]="rutasMostradas.has(ruta.numero)">
              {{ ruta.cantidadPuntos }} puntos
            </span>
          </div>

          <div class="card-body">
            <div class="row mb-2">
              <div class="col-md-4">
                <p class="mb-1">Punto inicial:</p>
                <p class="mb-0"><strong>{{ ruta.puntoInicial }}</strong></p>
              </div>
              <div class="col-md-8">
                <p class="mb-1">Punto final:</p>
                <p class="mb-0"><strong>{{ ruta.puntoFinal }}</strong></p>
              </div>
            </div>

            <!-- Alerta de continuidad (excepto para la última ruta) -->
            <div *ngIf="!ruta.esUltima" class="alert alert-warning d-flex align-items-center mb-2" role="alert">
              <mdb-icon fas icon="link" class="mr-2"></mdb-icon>
              <small>La siguiente ruta comienza desde el punto final de esta ruta (continuidad)</small>
            </div>

            <!-- Alerta visual cuando se muestra la ruta -->
            <div *ngIf="alertasRutas.get(ruta.numero)" class="alert alert-success alert-dismissible fade show mb-2"
              role="alert">
              <mdb-icon fas icon="check-circle" class="mr-2"></mdb-icon>
              <strong>Ruta {{ ruta.numero }} activa:</strong> Esta ruta se mostrará en el mapa principal.
              <button type="button" class="close" (click)="alertasRutas.set(ruta.numero, false)" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <!-- Botón para mostrar ruta en mapa -->
            <button type="button" class="btn btn-block" [class.btn-danger]="!rutasMostradas.has(ruta.numero)"
              [class.btn-success]="rutasMostradas.has(ruta.numero)" mdbBtn mdbWavesEffect
              (click)="mostrarRutaEnMapa(ruta)">
              <mdb-icon *ngIf="!rutasMostradas.has(ruta.numero)" fas icon="map-marked-alt" class="mr-2"></mdb-icon>
              <mdb-icon *ngIf="rutasMostradas.has(ruta.numero)" fas icon="check-circle" class="mr-2"></mdb-icon>
              {{ rutasMostradas.has(ruta.numero) ? 'Ruta ' + ruta.numero + ' Mostrada' : 'MOSTRAR RUTA ' +
              ruta.numero + ' EN MAPA' }}
            </button>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-success" mdbBtn mdbWavesEffect (click)="cerrar()">
          CERRAR
        </button>
      </div>
    </div>
  </div>
</div>